// Frans: webteksten van 'Soera's leren' (golf 7). Tutoiement comme app.fr.ts, vaste spatie voor
// de hoge leestekens. POORT: moedertaalreview.
export const appMemorizeFr = {
    title: 'Apprendre des sourates',
    nav: 'Apprentissage',
    card: {
        body: 'Suivre les sourates que vos enfants apprennent par cœur. Un enfant récite, tu écoutes pour de vrai et tu dis « Bien entendu ». Les points ne viennent qu’à ce moment-là.',
        question: 'Suivre ?',
        yes: 'Oui',
        notNow: 'Non, pas maintenant',
        notNowDone: 'D’accord. Tu peux toujours l’activer ici plus tard.',
        on: 'Activé pour {names}.',
        open: 'Aller à Apprentissage',
        settings: 'Réglages',
        renewal: 'Donne d’abord à nouveau ton accord dans Ce qui convient à notre famille.',
    },
    wizard: {
        title: 'Activer Apprendre des sourates',
        step: 'Étape {n} sur 4',
        back: 'Précédent',
        next: 'Suivant',
        done: 'Activer',
        who: {
            title: 'Qui participe ?',
            body: 'Active qui participe. Les enfants de moins de 16 ans pour qui tu décides.',
            teen: '{name} décide seul. Cela viendra plus tard.',
            otherFaith: '{name} a son propre choix de religion et ne participe pas.',
            none: 'Il n’y a pas d’enfant de moins de 16 ans dans la famille.',
            pick: 'Active au moins un enfant.',
            and: 'et',
            joins: 'Participe',
            paused: 'Ne participe pas pour l’instant. La progression est conservée.',
            notYet: 'Ne participe pas',
            toggle: '{name} participe',
            later: 'Activer demande d’abord ton accord pour cet enfant. Désactiver conserve la progression.',
            more: 'Faire participer quelqu’un d’autre ?',
            choose: 'Choisir des enfants',
            turnedOn: '{name} participe.',
            turnedOff: '{name} ne participe pas pour l’instant. La progression est conservée.',
        },
        naming: {
            title: 'Comment appelez-vous les sourates ?',
            turkish: 'Fâtiha, İhlâs, Kevser',
            arabic: 'Al-Fâtiha, Al-Ikhlâs, Al-Kawthar',
            order: 'Ordre',
            recommended: 'Recommandé : {fatiha}, puis les plus courtes',
            prayer: 'Ordre de la prière : {fatiha}, puis {fil} jusqu’à {nas}',
        },
        board: {
            title: 'Afficher sur le tableau ?',
            body: 'Toute personne devant le tableau voit cela pour l’enfant choisi.',
            yes: 'Oui, sur le tableau',
            no: 'Non, seulement dans l’appli',
        },
        known: {
            title: 'Que connaît déjà chaque enfant ?',
            body: 'Coche ce qu’un enfant connaît déjà par cœur. Cela ne donne ni points ni fête.',
        },
    },
    consent: {
        title: 'Accord pour {name}',
        text: 'Nous suivons pour {name} les sourates que {name} apprend et connaît, uniquement pour votre famille. Tu peux retirer cet accord à tout moment ; nous effaçons alors la progression.',
        check: 'Je suis parent ou tuteur de {name} et je donne mon accord.',
        textMany: 'Nous suivons pour {name} les sourates que {name} apprennent et connaissent, uniquement pour votre famille. Tu peux retirer cet accord à tout moment ; nous effaçons alors la progression.',
        checkMany: 'Je suis parent ou tuteur de {name} et je donne mon accord.',
        give: 'Donner mon accord',
        withdraw: 'Retirer l’accord',
        withdrawConfirm: 'Retirer l’accord pour {name} ? Cela efface tout de suite la progression de {name}. Les points gagnés restent.',
        withdrawn: 'Accord retiré. La progression de {name} est effacée.',
        given: 'Accord donné le {date}.',
        none: 'Pas encore d’accord',
    },
    stage: {
        none: 'Pas encore commencé',
        learning: 'En cours',
        ready: 'Veut réciter',
        known: 'Par cœur',
        review: 'Petite révision',
    },
    overview: {
        subtitle: 'Les sourates que les enfants apprennent par cœur. Chacun à son rythme.',
        now: 'En ce moment : {item}',
        nothing: 'Rien de commencé',
        next: 'Ensuite : {item}',
        allKnown: '{name} connaît toute la liste par cœur',
        waiting: 'En attente d’écoute ({count})',
        refresh: 'À réviser : {items}',
        list: 'La liste',
        settings: 'Réglages',
        open: 'Voir',
        paused: 'Apprendre des sourates est désactivé. Désactiver n’efface rien maintenant. Après 12 mois désactivé, la progression est effacée.',
        notSet: 'Apprendre des sourates n’est pas encore activé.',
        setUp: 'Activer',
        noConsent: 'Pas encore d’accord',
        disabled: 'Ne participe pas pour le moment',
        selfDecides: 'Décide seul ; viendra plus tard',
    },
    member: {
        progress: '{x} sur {y} par cœur',
        orderLearn: 'Ordre d’apprentissage',
        orderMushaf: 'Ordre du mushaf',
        menu: 'Que veux-tu faire avec {item} ?',
        start: 'Commencer',
        ready: 'Veut réciter',
        approve: 'Bien entendu',
        practice: 'Encore un peu d’entraînement',
        markKnown: 'A récité celle-ci',
        baseline: 'La connaissait déjà',
        refresh: 'Petite révision',
        heard: 'Bien entendu',
        revert: 'Validé par erreur',
        revertConfirm: 'Annuler ? {item} revient ensuite sur En cours.',
        revertPoints: 'Les {count} points de {item} sont retirés.',
        negative: 'Le solde de {name} devient alors négatif. Annuler quand même ?',
        reset: 'Effacer',
        resetConfirm: 'Effacer {item} pour {name} ? Cela revient ensuite sur Pas encore commencé.',
        confirm: 'Oui',
        cancel: 'Non',
        upto: 'Jusqu’au verset',
        uptoHint: 'Pour une sourate plus longue : jusqu’où {name} la connaît déjà ?',
        uptoSave: 'Enregistrer',
        uptoClear: 'Vider',
        uptoShort: 'jusqu’au verset {n}',
        listen: 'Écouter sur Quran.com',
        verses: { one: '{count} verset', other: '{count} versets' },
        points: { one: '{count} point', other: '{count} points' },
        reviewRound: 'Tour de révision',
        reviewRoundBody: 'Réécoute quelques sourates connues. Pas de points, juste une petite révision.',
        reviewRoundEmpty: 'Rien à réviser pour le moment.',
        reviewRoundDone: 'Tour de révision terminé.',
        inactive: 'Plus dans la liste',
        extra: 'Extra',
        heardBy: 'Entendu par',
        heardParent: 'moi',
        heardTeacher: 'l’enseignant (hoca, maîtresse)',
        milestones: 'Étapes',
        divider: '{fatiha} et les dix courtes sourates',
        milestone: {
            fatiha: '{fatiha} par cœur',
            prayer_set: '{fatiha} et les dix courtes sourates',
            starter_set: 'Les vingt premières sourates',
        },
        done: 'Enregistré.',
        childBody: 'Touche le bouton pour commencer ou pour réciter.',
        childStart: 'Je commence celle-ci',
        childReady: 'Je la connais par cœur',
        childOops: 'Oups',
        childReadyDone: 'Super. Un parent va bientôt écouter.',
        agedOut: 'À partir de 16 ans, la décision revient à {name}. En enregistrant, la progression de {name} dans Apprendre des sourates est effacée ; les points restent.',
        /** Golf 7 live r1: bevestiging vóór een geboortedatum die een meedoend kind 16+ maakt. */
        agedOutBirth: {
            title: 'Enregistrer la date de naissance ?',
            body: 'Avec cette date de naissance, {name} a 16 ans ou plus. À partir de 16 ans, la décision revient à {name} : en enregistrant, la progression de {name} dans Apprendre des sourates est effacée. Les points restent.',
            confirm: 'Enregistrer et effacer',
        },
    },
    list: {
        body: 'Les points sont les mêmes pour tous les enfants.',
        rewardsOff: 'Récompenses est désactivé : aucun point n’est donné.',
        up: 'Monter {item}',
        down: 'Descendre {item}',
        drag: 'Faire glisser pour déplacer',
        active: 'Dans la liste',
        points: 'Points',
        presets: 'Ordre en un geste',
        recommended: 'Recommandé',
        prayer: 'Ordre de la prière',
        more: 'Ajouter',
        moreBody: 'Extra : Âyat al-Kursî (un verset, pas une sourate). Et les sourates 95 à 78.',
        add: 'Ajouter',
        remove: 'Retirer de la liste',
        save: 'Enregistrer la liste',
        saved: 'Liste enregistrée.',
        keptNote: 'Conservé, car il y a une progression.',
    },
    settings: {
        naming: 'Noms',
        namingTurkish: 'Turc : Fâtiha, İhlâs, Kevser',
        namingArabic: 'Arabe : Al-Fâtiha, Al-Ikhlâs, Al-Kawthar',
        riwaya: 'Lecture',
        hafs: 'Hafs',
        warsh: 'Warsh',
        warshNote: 'Avec Warsh, nous n’affichons ni numéros de versets ni lien : le décompte varie selon l’édition.',
        refresh: 'Réviser après',
        days: '{count} jours',
        never: 'Jamais',
        board: 'Afficher sur le tableau',
        boardNote: 'Toute personne devant le tableau voit cela pour l’enfant choisi.',
        consent: 'Accord par enfant',
        wipe: 'Effacer la progression de tous',
        wipeBody: 'Efface toute la progression, la liste et les réglages, et retire les accords. Les points gagnés restent.',
        wipeConfirm: 'Tout effacer ? Cela ne peut pas être annulé.',
        wiped: 'Apprendre des sourates a été effacé.',
        off: 'Désactiver',
        offNote: 'Désactiver n’efface rien maintenant. Après 12 mois désactivé, la progression est effacée.',
        on: 'Réactiver',
        pointsNote: 'Après effacement, les points gagnés restent. Si tu le réactives plus tard, une sourate peut de nouveau donner des points.',
        saved: 'Enregistré.',
    },
    approvals: {
        title: 'Réciter',
        wants: '{name} veut réciter {item}',
        wantsAgain: '{name} veut réciter {item} encore une fois',
        since: 'Depuis {time}',
        points: { one: '{count} point avec Bien entendu', other: '{count} points avec Bien entendu' },
        approve: 'Bien entendu',
        practice: 'Encore un peu d’entraînement',
        heardBy: 'Entendu par',
        me: 'moi',
        teacher: 'l’enseignant (hoca, maîtresse)',
        already: 'Déjà fait.',
        approved: '{item} : bien entendu.',
        practiced: 'Encore un peu d’entraînement. {name} pourra la réciter plus tard.',
        seen: 'Vu',
        milestone: '{name} : {text}',
    },
    errors: {
        stale_stage: 'Déjà fait.',
        revert_first: 'Annule d’abord avec Validé par erreur.',
        not_eligible: 'Cet enfant ne participe pas (encore).',
        consent_renewal_required: 'Donne d’abord à nouveau ton accord dans Ce qui convient à notre famille.',
    },
};
//# sourceMappingURL=memorizeApp.fr.js.map